import { render, staticRenderFns } from "./bottom-bar.vue?vue&type=template&id=c7665660"
import script from "./bottom-bar.vue?vue&type=script&lang=js"
export * from "./bottom-bar.vue?vue&type=script&lang=js"
import style0 from "./bottom-bar.vue?vue&type=style&index=0&id=c7665660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports